export const PROVINCIAS = [
    {
        codProvincia: "",
        desProvincia: "",
        codISO: ""
    },
    {
        codProvincia: "01",
        desProvincia: "ARABA/ÁLAVA",
        codISO: "VI"
    },
    {
        codProvincia: "02",
        desProvincia: "ALBACETE",
        codISO: "AB"
    },
    {
        codProvincia: "03",
        desProvincia: "ALICANTE/ALACANT",
        codISO: "A"
    },
    {
        codProvincia: "04",
        desProvincia: "ALMERÍA",
        codISO: "AL"
    },
    {
        codProvincia: "05",
        desProvincia: "ÁVILA",
        codISO: "AV"
    },
    {
        codProvincia: "06",
        desProvincia: "BADAJOZ",
        codISO: "BA"
    },
    {
        codProvincia: "07",
        desProvincia: "ILLES BALEARS",
        codISO: "PM"
    },
    {
        codProvincia: "08",
        desProvincia: "BARCELONA",
        codISO: "B"
    },
    {
        codProvincia: "09",
        desProvincia: "BURGOS",
        codISO: "BU"
    },
    {
        codProvincia: "10",
        desProvincia: "CÁCERES",
        codISO: "CC"
    },
    {
        codProvincia: "11",
        desProvincia: "CÁDIZ",
        codISO: "CA"
    },
    {
        codProvincia: "12",
        desProvincia: "CASTELLÓN/CASTELLÓ",
        codISO: "CS"
    },
    {
        codProvincia: "13",
        desProvincia: "CIUDAD REAL",
        codISO: "CR"
    },
    {
        codProvincia: "14",
        desProvincia: "CÓRDOBA",
        codISO: "CO"
    },
    {
        codProvincia: "15",
        desProvincia: "A CORUÑA",
        codISO: "C"
    },
    {
        codProvincia: "16",
        desProvincia: "CUENCA",
        codISO: "CU"
    },
    {
        codProvincia: "17",
        desProvincia: "GIRONA",
        codISO: "GI"
    },
    {
        codProvincia: "18",
        desProvincia: "GRANADA",
        codISO: "GR"
    },
    {
        codProvincia: "19",
        desProvincia: "GUADALAJARA",
        codISO: "GU"
    },
    {
        codProvincia: "20",
        desProvincia: "GUIPUZKOA",
        codISO: "SS"
    },
    {
        codProvincia: "21",
        desProvincia: "HUELVA",
        codISO: "H"
    },
    {
        codProvincia: "22",
        desProvincia: "HUESCA",
        codISO: "HU"
    },
    {
        codProvincia: "23",
        desProvincia: "JAÉN",
        codISO: "J"
    },
    {
        codProvincia: "24",
        desProvincia: "LEÓN",
        codISO: "LE"
    },
    {
        codProvincia: "25",
        desProvincia: "LLEIDA",
        codISO: "L"
    },
    {
        codProvincia: "26",
        desProvincia: "LA RIOJA",
        codISO: "LO"
    },
    {
        codProvincia: "27",
        desProvincia: "LUGO",
        codISO: "LU"
    },
    {
        codProvincia: "28",
        desProvincia: "MADRID",
        codISO: "M"
    },
    {
        codProvincia: "29",
        desProvincia: "MÁLAGA",
        codISO: "MA"
    },
    {
        codProvincia: "30",
        desProvincia: "MURCIA",
        codISO: "MU"
    },
    {
        codProvincia: "31",
        desProvincia: "NAVARRA",
        codISO: "NA"
    },
    {
        codProvincia: "32",
        desProvincia: "OURENSE",
        codISO: "OR"
    },
    {
        codProvincia: "33",
        desProvincia: "ASTURIAS",
        codISO: "O"
    },
    {
        codProvincia: "34",
        desProvincia: "PALENCIA",
        codISO: "P"
    },
    {
        codProvincia: "35",
        desProvincia: "LAS PALMAS",
        codISO: "GC"
    },
    {
        codProvincia: "36",
        desProvincia: "PONTEVEDRA",
        codISO: "PO"
    },
    {
        codProvincia: "37",
        desProvincia: "SALAMANCA",
        codISO: "SA"
    },
    {
        codProvincia: "38",
        desProvincia: "SANTA CRUZ DE TENERIFE",
        codISO: "TF"
    },
    {
        codProvincia: "39",
        desProvincia: "CANTABRIA",
        codISO: "S"
    },
    {
        codProvincia: "40",
        desProvincia: "SEGOVIA",
        codISO: "SG"
    },
    {
        codProvincia: "41",
        desProvincia: "SEVILLA",
        codISO: "SE"
    },
    {
        codProvincia: "42",
        desProvincia: "SORIA",
        codISO: "SO"
    },
    {
        codProvincia: "43",
        desProvincia: "TARRAGONA",
        codISO: "T"
    },
    {
        codProvincia: "44",
        desProvincia: "TERUEL",
        codISO: "TE"
    },
    {
        codProvincia: "45",
        desProvincia: "TOLEDO",
        codISO: "TO"
    },
    {
        codProvincia: "46",
        desProvincia: "VALENCIA/VALÈNCIA",
        codISO: "V"
    },
    {
        codProvincia: "47",
        desProvincia: "VALLADOLID",
        codISO: "VA"
    },
    {
        codProvincia: "48",
        desProvincia: "BIZKAIA",
        codISO: "BI"
    },
    {
        codProvincia: "49",
        desProvincia: "ZAMORA",
        codISO: "ZA"
    },
    {
        codProvincia: "50",
        desProvincia: "ZARAGOZA",
        codISO: "Z"
    },
    {
        codProvincia: "51",
        desProvincia: "CEUTA",
        codISO: "CE"
    },
    {
        codProvincia: "52",
        desProvincia: "MELILLA",
        codISO: "ML"
    },
    {
        codProvincia: "99",
        desProvincia: "EXTRANJERO",
        codISO: "EX"
    }
];

export const TIPOS_VIA = [
    {
        codTipoVia: "AG",
        desTipoVia: "AGRUPACION",
    },
    {
        codTipoVia: "AL",
        desTipoVia: "ALAMEDA",
    },
    {
        codTipoVia: "AP",
        desTipoVia: "APARTAMENTO",
    },
    {
        codTipoVia: "AV",
        desTipoVia: "AVENIDA",
    },
    {
        codTipoVia: "BD",
        desTipoVia: "BAJADA",
    },
    {
        codTipoVia: "BC",
        desTipoVia: "BARRANCO",
    },
    {
        codTipoVia: "BO",
        desTipoVia: "BARRIO",
    },
    {
        codTipoVia: "BL",
        desTipoVia: "BLOQUE",
    },
    {
        codTipoVia: "C",
        desTipoVia: "CALLE",
    },
    {
        codTipoVia: "CJ",
        desTipoVia: "CALLEJON",
    },
    {
        codTipoVia: "CM",
        desTipoVia: "CAMINO",
    },
    {
        codTipoVia: "CR",
        desTipoVia: "CARRETERA",
    },
    {
        codTipoVia: "CS",
        desTipoVia: "CASAS",
    },
    {
        codTipoVia: "CH",
        desTipoVia: "CHALET",
    },
    {
        codTipoVia: "CO",
        desTipoVia: "COLONIA",
    },
    {
        codTipoVia: "CT",
        desTipoVia: "CUESTA",
    },
    {
        codTipoVia: "DS",
        desTipoVia: "DISEMINADO",
    },
    {
        codTipoVia: "ED",
        desTipoVia: "EDIFICIO",
    },
    {
        codTipoVia: "GL",
        desTipoVia: "GLORIETA",
    },
    {
        codTipoVia: "GR",
        desTipoVia: "GRUPO",
    },
    {
        codTipoVia: "LG",
        desTipoVia: "LUGAR",
    },
    {
        codTipoVia: "MC",
        desTipoVia: "MERCADO",
    },
    {
        codTipoVia: "PQ",
        desTipoVia: "PARQUE",
    },
    {
        codTipoVia: "PD",
        desTipoVia: "PARTIDA",
    },
    {
        codTipoVia: "PJ",
        desTipoVia: "PASAJE",
    },
    {
        codTipoVia: "PS",
        desTipoVia: "PASEO",
    },
    {
        codTipoVia: "PZ",
        desTipoVia: "PLAZA",
    },
    {
        codTipoVia: "PL",
        desTipoVia: "PLAZUELA",
    },
    {
        codTipoVia: "PB",
        desTipoVia: "POBLADO",
    },
    {
        codTipoVia: "PG",
        desTipoVia: "POLIGONO",
    },
    {
        codTipoVia: "PR",
        desTipoVia: "PROLONGACION",
    },
    {
        codTipoVia: "RB",
        desTipoVia: "RAMBLA",
    },
    {
        codTipoVia: "RD",
        desTipoVia: "RONDA",
    },
    {
        codTipoVia: "SN",
        desTipoVia: "SENDA",
    },
    {
        codTipoVia: "SD",
        desTipoVia: "SUBIDA",
    },
    {
        codTipoVia: "TT",
        desTipoVia: "TORRENTE",
    },
    {
        codTipoVia: "TR",
        desTipoVia: "TRAVESIA",
    },
    {
        codTipoVia: "UR",
        desTipoVia: "URBANIZACION",
    }
];